module.exports = __webpack_public_path__ + "like-circle.738ffd1a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/media/articles/like-circle.png
// module id = 1425
// module chunks = 0